import { extendTheme } from '@chakra-ui/react';

import {
  ASSETS_PRIMARY,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  NAVIGATION_COLOR,
  BG_LAYER,
  ASSET_BORDER,
  ASSET_BG,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: `"Tangerine", cursive;`,
    subHeading: `"Gilda Display", serif;`,
    subHeading_lv2: `"Sofia Sans", sans-serif;`,
    body: `"Quattrocento", serif;`,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '60px',
    subHeading: '22px',
    subHeading_lv2: '18px',
    body: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    subHeading_lv2: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-subHeading_lv2': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(166,68,128,1)',
    bgSecondary: 'rgba(243,244,225,1)',
    mainColorText: '#ffffff',
    secondaryColorText: '#fff8ed',
    alternativeColorText: 'rgba(230,100,201,1)',
    mainAssetColor: 'rgba(243,238,238,1)',
    borderAssetColor: 'rgba(255,255,255,0.25)',
    backgroundAssetColor: 'rgba(243,238,238,0.08)',
    bgLayer: 'rgba(248, 234, 231, 0.4)',
  },
  breakpoints: {
    base: '0em', // 0px
    sm: '30em', // ~480px
    md: '48em', // ~768px
    lg: '62em', // ~992px
    xl: '80em', // ~1280px
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
